import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { setPortal } from 'modules/portal';
import { hologramBanner } from 'lib/api/sales';
import {
  converParameters,
  makeRowColumn,
  getHeadObj,
  getHost,
} from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const HologramBanner = () => {
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    statsMth: moment().subtract(1, 'months').format('YYYYMM'),
    feeRate: 5,
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const customized = {
    STATS_MTH: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'STATS_MTH');
        let result;
        if (rowObj['STATS_MTH'] === 'Total') {
          result = t('합계');
        } else {
          result = makeRowColumn(
            rowObj['STATS_MTH'],
            bodyItem1.type,
            bodyItem1.format
          );
        }
        return result;
      },
    },
  };

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        const sDate = moment(rowObj['STATS_MTH'] + '01').format('YYYYMM01');
        let eDate;
        const newDate = moment().endOf('month').format('YYYYMM');
        const feeRate = rowObj['FEE_RATE'] * 100;

        if (String(rowObj['STATS_MTH']) === newDate) {
          eDate = moment().format('YYYYMMDD');
        } else {
          eDate = moment(sDate).endOf('month').format('YYYYMMDD');
        }

        const showWindowUrl = converParameters({
          url: getHost('new') + '/sales/revenue/hologramBannerDetail',
          sDate: sDate,
          eDate: eDate,
          adverId: rowObj['ADVER_ID'],
          feeRate: feeRate,
          uri: '/sales/revenue/hologramBannerDetail',
          isPop: 1,
        });

        return (
          rowObj['STATS_MTH'] !== 'Total' && (
            <IconAreaWrap
              icon="faExternalLink"
              toolTipTitle={t('광고주별 통계 팝업 제공')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          )
        );
      },
    });
    return result;
  })();

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useSingleDate
          useMonthDate
          singleDateId="statsMth"
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={hologramBanner}
        getParam={getParam}
        addColumnList={addColumnList}
        isIncludingTotal
        useTotal={true}
        customized={customized}
      />
    </>
  );
};

export default HologramBanner;
